import { Input, Modal, Select } from '@lib/components'
import type { ID } from '@octopus-do/octopus-project-core'
import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import type { ModalProps } from '@/types'
import { useSaveAsTemplate } from './hooks/useSaveAsTemplate'
import css from './styles.module.css'

export const SaveAsTemplate: React.FC<ModalProps> = ({ onClose }) => {
  const {
    name,
    workspaces,
    workspaceId,
    loadingWorkspaces,
    saving,
    error,
    changeName,
    setWorkspaceId,
    save,
  } = useSaveAsTemplate()

  // One workspace needs no choosing; the selector only appears when there is
  // an actual decision to make.
  const showWorkspaces = workspaces.length > 1

  return (
    <Modal
      classnames={{ content: css.modal, body: css.body }}
      onClose={onClose}
    >
      <div className={css.container}>
        <div className={css.title}>Save as template</div>

        <Input
          label="Template name"
          id="templateName"
          name="templateName"
          type="normal"
          initialValue={name}
          focusOnRender
          placeholder="e.g. Marketing site"
          onChange={changeName}
          onSubmit={save}
        />

        {showWorkspaces && (
          <Select
            label="Save to"
            selected={workspaceId}
            options={workspaces.map(({ id, title }) => ({
              value: id,
              label: title,
            }))}
            onChange={(value) => setWorkspaceId(String(value) as ID)}
          />
        )}

        {error && <div className={css.error}>{error}</div>}
      </div>

      <Button
        className={css.wide_button}
        label="Save template"
        loading={saving}
        disabled={loadingWorkspaces || !workspaceId}
        onClick={save}
      />
    </Modal>
  )
}
